"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetBusClassAnnotationSchema = exports.INetBusClassAnnotationInferedBusClassSchema = exports.INetBusClassAnnotationInferedBusClassSignalSchema = void 0;
const zod_1 = require("zod");
const NetAnnotationType_1 = require("../NetAnnotationType");
exports.INetBusClassAnnotationInferedBusClassSignalSchema = zod_1.default.object({
    classSignalId: zod_1.default.string(),
    classSignalDisplayName: zod_1.default.string(),
    confidence: zod_1.default.number(),
});
exports.INetBusClassAnnotationInferedBusClassSchema = zod_1.default.object({
    busClassName: zod_1.default.string(),
    busClassDisplayName: zod_1.default.string(),
    confidence: zod_1.default.number(),
    classSignals: zod_1.default.array(exports.INetBusClassAnnotationInferedBusClassSignalSchema),
});
exports.INetBusClassAnnotationSchema = zod_1.default.object({
    net: zod_1.default.string(),
    type: zod_1.default.literal(NetAnnotationType_1.NetAnnotationType.BusClass),
    inferedBusClasses: zod_1.default.array(exports.INetBusClassAnnotationInferedBusClassSchema),
});
//# sourceMappingURL=NetBusClassAnnotationType.js.map